import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material/dialog";

@Component({
    selector: 'dialog-component',
    templateUrl: './dialog.component.html',
    styleUrls: ["./dialog.component.scss"],
    standalone: false
})
export class DialogComponent {
  constructor(
    public dialog: MatDialog
  ){
  }
  close(){
    this.dialog.closeAll()
  }
}
